import React from 'react';
import Popup from '../../../components/Popup';
import styled from 'styled-components';

const VisionVideoPopupStyle = styled.div``;
const VisionVideoPopup6 = (props) => {

    return (
        <VisionVideoPopupStyle>
            <Popup type="video" youtube_id="xqnN3YhKvDo" show={props.show} onClose={props.onClose}></Popup>
        </VisionVideoPopupStyle>
    );
};

export default VisionVideoPopup6;